import gsap from 'gsap';
import scrollLock from 'scroll-lock';

class Menu {
	constructor() {
		this.header = document.querySelector('[data-header]');
		this.menu = document.querySelector('[data-menu]');
		this.menuBtns = document.querySelectorAll('[data-menu-button]');
		this.isOverlay = false;
		this.isMenu = false;
		this.isSubscribe = false;
		this.menuItems = this.menu.querySelectorAll('a');
		this.backdrop = document.querySelector('[data-backdrop]');
		this.subscribeModal = document.querySelector('[data-subscribe-modal]');

		this.subscribeButton = this.menu.querySelector('[data-subscribe-button]');
		if (this.subscribeButton) {
			this.subscribeButton.addEventListener('click', (evt) => {
				evt.preventDefault();
				this.toggleSubscribe();
			});
		}

		this.menuBtns.forEach((btn) => {
			btn.addEventListener('click', () => {
				this.toggleMenu();
			});
		});

		this.menuLinks = this.menu.querySelectorAll('a');
		this.menuLinks.forEach((element) => {
			element.addEventListener('click', () => {
				this.closeAll();
				scrollLock.enablePageScroll();
			});
		});

		document.addEventListener('keydown', (evt) => {
			if (evt.key == 'Escape') {
				this.closeAll();
			}
		});

		this.backdrop.addEventListener('click', () => {
			this.closeAll();
		});

		document.addEventListener('toggle-subscribe-modal', (e) => {
			console.log('toggle-subscribe-modal');
			this.toggleSubscribe();
		});
	}

	toggleOverlay() {
		console.log('toggleOverlay', this.isOverlay);
		if (this.isOverlay) {
			this.closeOverlay();
		} else {
			this.openOverlay();
		}
	}

	closeAll() {
		this.closeMenu();
		this.closeSubscribe();
		this.closeOverlay();
	}

	toggleMenu() {
		console.log('toggleMenu', this.isMenu);
		if (this.isMenu) {
			this.closeAll();
		} else {
			this.openOverlay();
			this.openMenu();
			this.closeSubscribe();
		}
	}

	toggleSubscribe() {
		console.log('toggleSubscribe', this.isSubscribe);
		if (this.isSubscribe) {
			this.closeAll();
		} else {
			this.openOverlay();
			this.openSubscribe();
			this.closeMenu();
		}
	}

	openOverlay() {
		document.body.classList.add('has-overlay');

		gsap.set(this.backdrop, {
			zIndex: 101,
		});

		gsap.to(this.backdrop, {
			duration: 0.6,
			autoAlpha: 1,
			ease: 'power1.inOut',
		});

		this.menuBtns.forEach((btn) => {
			btn.classList.add('is-active');

			if (btn.classList.contains('c-header__menu-toggle')) {
				btn.innerHTML = 'close';
				btn.setAttribute('data-text', 'close');
			}
		});

		this.isOverlay = true;
	}

	closeOverlay() {
		document.body.classList.remove('has-overlay');

		gsap.to(this.backdrop, {
			duration: 0.6,
			autoAlpha: 0,
			ease: 'power1.inOut',
			clearProps: 'zIndex',
		});

		this.menuBtns.forEach((btn) => {
			btn.classList.remove('is-active');

			if (btn.classList.contains('c-header__menu-toggle')) {
				btn.innerHTML = 'menu';
				btn.setAttribute('data-text', 'menu');
			}
		});

		this.isOverlay = false;
	}

	openSubscribe() {
		console.log('openSubscribe');

		this.subscribeModal.classList.add('is-open');
		document.body.classList.add('subscribe-modal-open');

		this.isSubscribe = true;
	}

	closeSubscribe() {
		this.subscribeModal.classList.remove('is-open');
		document.body.classList.remove('subscribe-modal-open');

		this.isSubscribe = false;
	}

	openMenu() {
		this.menu.classList.add('is-active');
		document.body.classList.add('menu-open');

		this.trapFocus();
		this.isMenu = true;
	}

	closeMenu() {
		this.menu.classList.remove('is-active');
		document.body.classList.remove('menu-open');

		this.removeTrapFocus();
		this.isMenu = false;
	}

	showMenu() {
		document.body.classList.add('show-menu');
	}

	hideMenu() {
		document.body.classList.remove('show-menu');
	}

	showTicket() {
		document.body.classList.add('show-ticket');
	}

	trapFocus() {
		let focusableEls = this.header.querySelectorAll(
			'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])'
		);

		focusableEls = Array.from(focusableEls).filter((element) => {
			const style = getComputedStyle(element);
			return style.visibility !== 'hidden' && style.display !== 'none';
		});

		this.firstFocusableEl = focusableEls[0];
		this.lastFocusableEl = focusableEls[focusableEls.length - 1];

		this.tabfocussed = (event) => this.tabFocus(event);
		document.addEventListener('keydown', this.tabfocussed);
	}

	tabFocus(e) {
		const KEYCODE_TAB = 9;
		const isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB;

		if (!isTabPressed) {
			return;
		}

		if (e.shiftKey) {
			if (document.activeElement === this.firstFocusableEl) {
				this.lastFocusableEl.focus();
				e.preventDefault();
			}
		} else {
			if (document.activeElement === this.lastFocusableEl) {
				this.firstFocusableEl.focus();
				e.preventDefault();
			}
		}
	}

	removeTrapFocus(element) {
		document.removeEventListener('keydown', this.tabfocussed);
	}
}

const menu = new Menu();
export default menu;
